import { render, staticRenderFns } from "./WelcomePanel.vue?vue&type=template&id=07ff2602&scoped=true&"
import script from "./WelcomePanel.vue?vue&type=script&lang=js&"
export * from "./WelcomePanel.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePanel.vue?vue&type=style&index=0&id=07ff2602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff2602",
  null
  
)

export default component.exports